export var VERSION = '2.25.0';
//# sourceMappingURL=version.js.map